import { Component, OnDestroy } from '@angular/core';
import { NavController, AlertController, ToastController, ViewController, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  template: `
    <ion-header>
      <ion-navbar [color]="customizer.getColorNavbar()">
        <ion-title>Privacy</ion-title>
        <ion-buttons left>
          <button ion-button clear icon-only (click)="dismiss()">
            <ion-icon name="close"></ion-icon>
            {{ "ANNULLA" | translate }}
          </button>
        </ion-buttons>
      </ion-navbar>
    </ion-header>
    <ion-content padding><div [innerHTML]="content"></div></ion-content>`
})
export class ModalPrivacyPage implements OnDestroy {
  private _onDestroy = new Subject();
  content; 

  constructor(public navCtrl: NavController,
    public translateService: TranslateService,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public provider: provider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public http: HttpClient,
    public customizer: CustomizerProvider) {

    this.provider.getPrivacy().takeUntil(this._onDestroy).subscribe((response) => {
      let resp = JSON.parse((<any>response)._body);
      this.content = resp.content;
    }, (error) => {
      console.log(error)
    })
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/modalPrivacy/modalPrivacy.ts